import { Run } from "types/generated";
import { isTerminalRunState } from "utils/run";

export const areRunLogsDeletable = (run: Run): boolean => isTerminalRunState(run.state);
